import type { ReactElement } from 'react';
import React from 'react';
import clsx from 'clsx';
import './skeleton.scss';

type Props = {
  isLoading?: boolean;
  isError?: boolean;
  numCards?: number;
};

export default function Skeleton({ isLoading, isError, numCards = 3 }: Props): ReactElement {
  return (
    <>
      {Array.from({ length: numCards }).map((_, i) => (
        // eslint-disable-next-line react/no-array-index-key
        <div key={i} className={clsx('card skeleton my-2', { loading: isLoading, error: isError })}>
          <div className="card-header">
            <div className="skeleton-box" style={{ width: '40ch' }} />
          </div>
          <div className="card-body">
            <svg viewBox="0 0 800 350">
              <g className="x-axis" transform="translate(0,250)">
                <g
                  className="axis"
                  fill="none"
                  fontSize="10"
                  fontFamily="sans-serif"
                  textAnchor="middle"
                >
                  <path className="domain" stroke="currentColor" d="M80.5,6V0.5H750.5V6" />
                </g>
              </g>
              <g className="y-axis" transform="translate(80,0)">
                <g
                  className="axis"
                  fill="none"
                  fontSize="10"
                  fontFamily="sans-serif"
                  textAnchor="end"
                >
                  <path className="domain" stroke="currentColor" d="M-6,250.5H0.5V20.5H-6" />
                </g>
              </g>
            </svg>
          </div>
        </div>
      ))}
    </>
  );
}
